import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Nav, NavItem } from "reactstrap";
import IntlMessages from "Util/IntlMessages";
import { getSuiteNav, type SuiteNavItem } from "./suiteNav";
import OverviewQuickLinks from "./OverviewQuickLinks";

/**
 * @param {{ vertical: string }} props
 */
export default function SuiteLayout({ vertical }: { vertical: string }) {
  const items = getSuiteNav(vertical) || [];

  return (
    <div className="dashboard-vertical dashboard-suite mb-4">
      <Nav className="suite-subnav border-bottom pb-2 mb-4 flex-wrap" pills>
        {items.map((item: SuiteNavItem) => (
          <NavItem key={item.to}>
            <NavLink
              to={item.to}
              end={item.end === true}
              className={({ isActive }) =>
                `nav-link rounded-pill px-3 py-2 me-1 mb-1 ${isActive ? "active" : ""}`
              }
            >
              <IntlMessages id={item.labelId} />
            </NavLink>
          </NavItem>
        ))}
      </Nav>
      <OverviewQuickLinks vertical={vertical} />
      <Outlet />
    </div>
  );
}
